import React from "react";
import { FaClipboardList, FaCogs, FaDesktop } from "react-icons/fa";
import SubscribeNewsletter from "../../pages/Home/SubscribeNewsletter";
import MetaData from "../../components/layout/MetaData";
import FaqQuoteForm from "../Policy/FaqQuoteForm";

const faqs = [
  {
    question: "How do I learn PCBA info?",
    answer: [
      "These professional electronic design and manufacturing businesses deliver fee-based services to assist you with the design, development and production of your concepts, products and services. The website allows you to search for providers based on industry, design capabilities, certifications and practical experience. Available services include hardware and software design, schematic design, PCB layout, prototype assembly & testing, high-volume manufacturing and various related support services.",
      "Simply send your product introductions to hello@creatyea.com or fill in below information and submit requests",
    ],
  },
];

const capabilityCards = [
  {
    title: "Design",
    icon: FaDesktop,
    items: [
      "PCBA",
      "Driver/BSP/SDK",
      "Mechanical",
      "Wiring",
      "Package",
      "Accesory",
      "Test Plan",
      "DFM/DFT",
      "Certification",
    ],
  },
  {
    title: "Deliverable",
    icon: FaClipboardList,
    items: [
      "PCB Schematic",
      "Electronics BOM List",
      "Firmware / Software",
      "Mechanical in STEP",
      "Test Plan and Report",
      "EVT/DVT Samples",
      "Licenses",
      "PCB Design ( IP )",
      "PCB GERBER ( IP )",
      "BOM ( IP )",
      "Firmware Source Code  ( IP )",
    ],
  },
  {
    title: "Manufacturing",
    icon: FaCogs,
    items: [
      "Miniumum of 5 Prototypes",
      "Mass Production Plan",
      "Optimized BOM with Substitutes",
      "1 ~ 5 Year Warranty",
      "Above 3 Years Lifetime",
      "Upgrade Product Plan",
    ],
  },
];

const processSteps = [
  {
    title: "Get Quotes",
    items: [
      "Send technical documents of project to Creatyea 's HW & SW Team, and should contain things specified as below:",
      "Specific product ideas such as PCB dimensions ( L x W )",
      "Including PCB 's DXF if possible.",
      "Decide what kind of structure would be required for Hardware",
      "Software detailed requirements",
      "Certification names",
      "Sign the NDA if needed",
    ],
  },
  {
    title: "Finalize Design",
    items: ["PCB Built", "Testing and Quality Control", "Ready for Licenses"],
  },
  {
    title: "Deliverable",
    items: [
      "An optimized BOM list with substitute components to avoid out of stock",
      "PCB GERBER",
      "Schematic in PDF",
      "PickAndPlace in csv or xls",
      "2D format",
      "3D in PDF",
      "Quotes based on mass produced quantities",
    ],
  },
  {
    title: "Manufacturing Progress",
    items: [
      "Product Introduction",
      "Manufacturing Progress",
      "Firmware / Software Programming if needed",
      "Quality Control",
      "Certifications",
      "Dropshipping in units or Global Logistics in bulk from mainland of China",
    ],
  },
  {
    title: "Lifecycle Plan",
    items: ["End of Life or Upgrade Plan"],
  },
];

/**
 * 渲染 ODM 顶部能力卡片。
 */
const OdmCapabilityCard = ({ card }) => {
  const Icon = card.icon;

  return (
    <article className="odm-market-capability-card">
      <div className="odm-market-card-heading">
        <Icon className="odm-market-card-icon" aria-hidden="true" />
        <h3>{card.title}</h3>
      </div>
      <ul>
        {card.items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </article>
  );
};

/**
 * 渲染 ODM 流程步骤卡片。
 */
const OdmProcessStep = ({ step, index }) => {
  return (
    <article className="odm-market-step-card">
      <div className="odm-market-step-badge">
        <span>{index + 1}</span>
        <span>Step</span>
      </div>
      <div className="odm-market-step-content">
        <h3>{step.title}</h3>
        <ul>
          {step.items.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </div>
    </article>
  );
};

/**
 * 渲染 ODM 服务页面。
 */
const OdmServicesScreen = () => {
  return (
    <>
      <MetaData title="ODM Services" />
      <div className="odm-market-page">
        <section className="odm-market-section">
          <h1>From Product Idea to Market</h1>

          <div className="odm-market-capability-grid">
            {capabilityCards.map((card) => (
              <OdmCapabilityCard card={card} key={card.title} />
            ))}
          </div>

          <div className="odm-market-process-grid">
            {processSteps.map((step, index) => (
              <OdmProcessStep step={step} index={index} key={step.title} />
            ))}
          </div>

          {/* FAQ Section integrated into ODM Services */}
          <div className="mt-12 space-y-8">
            <div className="bg-blue-50/50 rounded-xl p-6 border border-blue-100">
              {faqs.map((faq, index) => (
                <div key={index} className="space-y-4">
                  <h3 className="text-2xl font-bold text-gray-900">{faq.question}</h3>
                  {faq.answer.map((paragraph, pIndex) => (
                    <p key={pIndex} className="text-gray-700 leading-relaxed">
                      {paragraph}
                    </p>
                  ))}
                </div>
              ))}
            </div>

            <FaqQuoteForm />
          </div>

          <p className="odm-market-contact">
            Reach out to us for a quote today at{" "}
            <a href="mailto:hello@creatyea.com">hello@creatyea.com</a>
          </p>
        </section>
      </div>

      <SubscribeNewsletter />
    </>
  );
};

export default OdmServicesScreen;
